// SPDX-License-Identifier: LicenseRef-Proprietary
// Copyright (c) 2025 Mann Contractual Management Ltd

const prism = {
  ".changed": {
    color: `codeChanged`,
  },
  ".deleted": {
    color: `codeDeleted`,
  },
  ".inserted": {
    color: `codeInserted`,
  },
  ".attr-name": {
    color: `codeAttrName`,
  },
  ".comment": {
    color: `codeComment`,
  },
  ".string": {
    color: `codeString`,
  },
  ".url": {
    color: `codeUrl`,
  },
  ".variable": {
    color: `codeVariable`,
  },
  ".number": {
    color: `codeNumber`,
  },
  ".builtin": {
    color: `codeBuiltIn`,
  },
  ".char": {
    color: `codeChar`,
  },
  ".constant": {
    color: `codeConstant`,
  },
  ".function": {
    color: `codeFunction`,
  },
  ".punctuation": {
    color: `codePunctuation`,
  },
  ".selector": {
    color: `codeSelector`,
  },
  ".doctype": {
    color: `codeDoctype`,
  },
  ".class-name": {
    color: `codeClassName`,
  },
  ".tag": {
    color: `codeTag`,
  },
  ".operator": {
    color: `codeOperator`,
  },
  ".keyword": {
    color: `codeKeyword`,
  },
  ".boolean": {
    color: `codeBoolean`,
  },
  ".property": {
    color: `codeProperty`,
  },
  ".namespace": {
    color: `codeNamespace`,
  },
}

export default prism
